import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m25.214 6.309-.001-.001L20.11 1.23a.977.977 0 0 0-1.378 1.384l3.426 3.41H1.477a.977.977 0 1 0 0 1.953h20.681l-3.426 3.409a.977.977 0 1 0 1.378 1.384l5.103-5.078a.977.977 0 0 0 0-1.383Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow"}) } }